// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LightbulbOpenOutlinedSvg from "@fishx/icons-svg/es/asn/LightbulbOpenOutlined";
import FishxIcon from '../components/FishxIcon';

var LightbulbOpenOutlined = function LightbulbOpenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LightbulbOpenOutlinedSvg
  }));
};

LightbulbOpenOutlined.displayName = 'LightbulbOpenOutlined';
export default React.forwardRef(LightbulbOpenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LightbulbOpenOutlined.js
// module id = 3036
// module chunks = 0